import(/* webpackMode: "eager" */ "/app/src/app/about/contact/page.tsx");
